import { SET_CLEAR_ALL_FILTER } from '../actionTypes/ClearAllFilterTypes';

export const setClearAllFilter = (payload) => ({
    type: SET_CLEAR_ALL_FILTER,
    payload,
});

export default setClearAllFilter;
